import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class DoublyLinkedListNode {
  constructor(item, previous, next) {
    _defineProperty(this, "item", void 0);

    _defineProperty(this, "previous", void 0);

    _defineProperty(this, "next", void 0);

    this.item = item;
    this.previous = previous;
    this.next = next;
  }

}
//# sourceMappingURL=doubly-linked-list-node.js.map